import { useState } from "react";
import Chat from "../components/Chat";
import FileQuery from "../components/FileQuery";
import ContentTitle from "../layout/ContentTitle";

const ReguBot = () => {
  const [activeTab, setActiveTab] = useState("chat");
  const tabs = [
    {
      id: "chat",
      label: "Reg Specialist",
      content: <Chat />,
      tooltip: "Liaise with the Regulatory Specialist Assistant",
    },
    {
      id: "doc",
      label: "Doc SME",
      content: <FileQuery />,
      tooltip:
        "Engage the Subject Matter Expert for the uploaded document insights",
    },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="flex h-[calc(100vh-40px)] w-full flex-col">
      <ContentTitle title={"Regulify Virtual Assistant"} />

      <div className="tabs tabs-boxed mt-4">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`
              tab m-1
              text-sm md:text-base
              tracking-wide
              transition-all duration-300 ease-in-out
              ${isActive
                  ? `
                  tab-active
                  scale-105
                  font-bold
                  bg-base-300
                  text-primary/80
                  border-b-4 border-primary
                  shadow-md
                `
                  : `
                  font-medium

                  // text-gray-500
                  // dark:text-gray-400
                  // hover:bg-base-200
                  // dark:hover:bg-base-300

                  text-base-content
                  opacity-90
                  border border-transparent
                  bg-base-200
                  hover:opacity-100
                  dark:bg-base-300
                `
                }
            `}
            >
              <span className="tooltip tooltip-bottom flex w-full h-full items-center justify-center" data-tip={tab.tooltip}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>

      <div className="card bg-base-100 mt-1 flex flex-1 flex-col overflow-hidden p-1 shadow-xl">
        {tabs.find((tab) => tab.id === activeTab)?.content}
      </div>
    </div>
  );
};

export default ReguBot;
